/**
 * Owner: Masa Bayu
 * File: script-relation.ts
 * Date:Time: 2026-09-19 15:55
 * Description: languageId → scriptId relationship resolution (GL-02).
 */
import { normalizeLanguageId } from './language-id';
import { QX_DEFAULT_SCRIPT_BY_PRIMARY, resolveScriptHint } from './script-hints';
import { createQxScriptIdentity } from './script-identity';
/**
 * Resolve language → script relationship.
 * Prefer script subtag on languageId; else primary-language default hint; else none.
 */
export function resolveLanguageScriptRelation(languageIdRaw) {
    const parsed = normalizeLanguageId(languageIdRaw);
    const explicit = parsed.script;
    const hinted = resolveScriptHint(parsed);
    let source = 'none';
    if (explicit) {
        source = 'tag';
    }
    else if (hinted && QX_DEFAULT_SCRIPT_BY_PRIMARY[parsed.primary] === hinted) {
        source = 'primary_default';
    }
    else if (hinted) {
        source = 'primary_default';
    }
    const resolvedScriptId = hinted;
    return Object.freeze({
        languageId: parsed.languageId,
        primary: parsed.primary,
        explicitScriptFromTag: explicit,
        resolvedScriptId,
        source,
        script: resolvedScriptId ? createQxScriptIdentity({ scriptId: resolvedScriptId }) : null,
    });
}
//# sourceMappingURL=script-relation.js.map